"use strict";
/**
 * Public Material Database Record Types
 *
 * RECORD STRUCTURE (2-record model, consolidated 2026-05):
 * A public material is persisted as exactly TWO record kinds —
 *   - display#public  (browsable catalog row; single source of truth for current content,
 *                      carries GSI2 hierarchy keys + counters + ALL content fields)
 *   - version#{N}      (immutable snapshot, no GSI keys)
 * The former `details#public` material record was ELIMINATED: its content lives entirely on
 * display#public, which every reader now sources current content from. No handler writes,
 * reads, or deletes a `public_material#{id}` + `details#public` record.
 * Writers:  approve-new-material.ts, approve-add-variation.ts, approve-create-parent.ts,
 *           approve-nonstandard-material.ts, create-material-parent.ts, update-public-material.ts
 *           (each writes display#public + version#{N} only)
 * Readers:  material-versions.ts (current version sourced from display#public),
 *           approve-material-update.ts
 * Deleters: delete-material.ts, delete-parent-material.ts, merge-materials.ts
 *           (delete display#public + version records; no details delete)
 * NOTE: the SK string `details#public` is still used by UNRELATED pattern (`pattern#{id}`)
 * and project (`project#{id}`) records — those are a different feature and are NOT covered here.
 * Variations use GSI2 keys for hierarchy queries.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MATERIAL_EDIT_ALLOWLIST = void 0;
// ===== MODERATOR MATERIAL EDIT ALLOW-LIST =====
/**
 * Allow-list of public-material fields a moderator may edit in-place during flag resolution
 * (`resolveMaterialFlag`). M4 (moderation-actions-remediation Req 7, Decision C).
 *
 * `specifications` is DELIBERATELY EXCLUDED: it is an arbitrary, unscanned, unindexed bag absent
 * from `PublicMaterialResponse`, so blessing it would legitimize writing arbitrary nested
 * unvalidated JSON into the live public record rather than constrain the edit surface. It is
 * carried forward UNCHANGED by SP-M9's atomic edit transaction. Protected attributes (`GSI3PK`,
 * `contributed_by`, `version`, counters) are not on the list and can never be written by an edit.
 *
 * Consumed by `resolveMaterialFlag` to intersect/validate `ResolveFlagRequest.edits` before
 * building the `display#public` + `version#{N}` update expressions (SP-M9, Req 23).
 */
exports.MATERIAL_EDIT_ALLOWLIST = ['name', 'brand', 'category', 'description', 'images'];
